// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
/* Footer.css */
.Footer {
  background-color: var(--color-bg);
  color: var(--color-fg);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1.5rem;
  z-index: 50;
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

.Footer-content {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
}

.Footer-nav {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  width: 100%;
}
.Footer-nav a {
  text-decoration: none;
  color: var(--color-fg);
}
.Footer-nav a:hover {
  color: var(--color-hover);
}

.Footer-nav div {
  display: flex;
  gap: 1rem;
}
@media (max-width: 767px) {
  .Footer-nav div {
    gap: 0.8rem;
  }
}

.Footer p {
  margin: 0;
  padding-bottom: 1rem;
}

.Footer-social {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  padding-right: 2em;
}
@media (max-width: 767px) {
  .Footer-social {
    gap: 1rem;
  }
}

.Footer-social a {
  display: inline-block;
  background-color: var(--color-bg);
  border-radius: 2px;
  font-size: 20px;
  color: var(--color-fg);
  text-align: center;
  line-height: 35px;
  transition: transform var(--transition-time);
}

.Footer-social a:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  color: var(--color-hover);
}

.Footer-gitInfo {
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
}
.Footer-gitInfo div {
  position: absolute;
  top: 0px;
  color: var(--color-fg-opacity);
}
.Footer-gitInfo div a {
  color: var(--color-fg-opacity);
}

@media (max-width: 767px) {
  .Footer {
    padding: 1rem 0.5rem 0.5rem;
  }
  .Footer-nav, .Footer-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .Footer-gitInfo {
    justify-content: start;
  }
  .Footer-gitInfo div {
    position: relative;
  }
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Footer.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA,eAAA;AACA;EACI,iCAAA;EACA,sBAAA;EAEA,8BAAA;EACA,2BAAA;EACA,sBAAA;EAEA,eAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAII;EACI,qBAAA;EACA,sBAAA;AAFR;AAKI;EACI,yBAAA;AAHR;;AAOA;EACI,aAAA;EACA,SAAA;AAJJ;ADtCE;ECwCF;IAIQ,WAAA;EAFN;AACF;;AAKA;EACI,SAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;ADvDE;ECqDF;IAOQ,SAAA;EADN;AACF;;AAIA;EACI,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;AADJ;;AAIA;EACI,qBAAA;EACA,6BAAA;EACA,yBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AADJ;AAGI;EACI,kBAAA;EACA,QAAA;EACA,8BAAA;AADR;AAGQ;EACI,8BAAA;AADZ;;AD5FE;ECmGE;IACI,2BAAA;EAHN;EAKE;IACI,sBAAA;IACA,uBAAA;EAHN;EAKE;IACI,sBAAA;EAHN;EAKM;IACI,kBAAA;EAHV;AACF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use '../styles';\n\n/* Footer.css */\n.Footer {\n    background-color: var(--color-bg);\n    color: var(--color-fg);\n\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n\n    padding: 1.5rem; \n    z-index: 50;\n    display: flex;\n    gap: 1rem;\n    flex-direction: column;\n}\n\n.Footer-content {\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.Footer-nav {\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n    width: 100%;\n\n    a {\n        text-decoration: none;\n        color: var(--color-fg);\n    }\n\n    a:hover {\n        color: var(--color-hover);\n    }\n}\n\n.Footer-nav div {\n    display: flex;\n    gap: 1rem;\n    @include styles.mobile {\n        gap: .8rem;\n    }\n}\n\n.Footer p {\n    margin: 0;\n    padding-bottom: 1rem;\n}\n\n.Footer-social {\n    display: flex;\n    gap: .8rem;\n    align-items: center;\n    padding-right: 2em;\n\n    @include styles.mobile {\n        gap: 1rem;\n    }\n}\n\n.Footer-social a {\n    display: inline-block;\n    background-color: var(--color-bg);\n    border-radius: 2px;\n    font-size: 20px;\n    color: var(--color-fg);\n    text-align: center;\n    line-height: 35px;\n    transition: transform var(--transition-time);\n}\n\n.Footer-social a:hover {\n    transform:scale(1.1); \n    -webkit-transform:scale(1.1);\n    color: var(--color-hover);\n}\n\n.Footer-gitInfo {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    position: relative;\n\n    div {\n        position: absolute;\n        top: 0px;\n        color: var(--color-fg-opacity);\n\n        a {\n            color: var(--color-fg-opacity);\n        }\n    }\n}\n\n@include styles.mobile {\n    .Footer {\n        padding: 1rem 0.5rem 0.5rem;\n    }\n    .Footer-nav, .Footer-content {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    .Footer-gitInfo {\n        justify-content: start;\n\n        div {\n            position: relative;\n        }\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
